import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../components/Layout/MainLayout";
import { BackIcon } from "../../../components/Dashboard/DataCenterIcons";
import "../../../assets/styles/rdccount.css";
import { ROUTES } from "../../../utils/constants";
import { commonService } from "../../../services/commonService";

const CDCount: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { filters, results } = location.state || { filters: null, results: [] };
    const contactCount = results?.contact_count ?? 0;
    const companyCount = results?.company_count ?? 0;

    const [maxContactsPerCompany, setMaxContactsPerCompany] = useState("");
    const [noOfContacts, setNoOfContacts] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [trackId, setTrackId] = useState<string | null>(null);

    const isButtonEnabled =
        maxContactsPerCompany.trim() !== "" || noOfContacts.trim() !== "";

    const handleDownload = async () => {
        setIsLoading(true);
        setTrackId(null); // reset previous track ID

        try {
            const payload = {
                ...filters,
                max_contacts_per_company: maxContactsPerCompany && parseInt(maxContactsPerCompany) > 0
                    ? parseInt(maxContactsPerCompany)
                    : contactCount,
                max_contacts: noOfContacts && parseInt(noOfContacts) > 0
                    ? parseInt(noOfContacts)
                    : contactCount
            };

            // 👉 Call your download API here
            const response = await commonService.rdcDownloadRequest(payload);

            // Assume backend returns: { success: true, track_id: "ABC12345" }
            if (response?.request_id) {
                setTrackId(response.request_id);
            }
            // Clear fields
            setMaxContactsPerCompany("");
            setNoOfContacts("");

        } catch (err) {
            // console.error("Download failed:", err);
            // Clear fields
            setMaxContactsPerCompany("");
            setNoOfContacts("");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <MainLayout>
            <div className="regular-rdc-page custom-scrollbar">
                <main className="regular-rdc-main">
                    <div className="regular-rdc-section-header">
                        <button
                            onClick={() => navigate(-1)}
                            className="regular-rdc-back-button"
                        >
                            <BackIcon /> Back
                        </button>
                    </div>

                    <div className="rdc-results-summary">
                        <h2 className="rdc-results-title">Search Results</h2>
                        <div className="rdc-results-stats text-center">
                            <p className="w-100">
                                A total of <strong>{contactCount}</strong> contacts were found across <strong>{companyCount}</strong> unique companies.
                            </p>
                        </div>
                    </div>
                </main>
            </div>
        </MainLayout>
    );
};

export default CDCount;
